import { isLightTheme } from '../../utils';

import type { OverWritable } from '../../@types/settings';

export const slider: OverWritable = {
  MuiSlider: {
    defaultProps: {
      size: 'small',
    },

    styleOverrides: {
      root: ({ theme }) => ({
        '&.Mui-disabled': {
          color: theme.palette.action.disabled,
        },
      }),
      markLabel: ({ theme }) => ({
        fontSize: 13,
        color: theme.palette.text.disabled,
      }),
      valueLabel: ({ theme }) => ({
        borderRadius: 8,
        backgroundColor: theme.palette.grey[isLightTheme(theme) ? 800 : 700],
      }),
    },
  },
};
